//  Search
$('.main-nav .icon_search').click(function() {
    $(this).parent().find('.search-input').addClass('show');
    $(this).addClass('active');
});

// Scroll To Top
function scrolltotop() {
    var scrollToTop = $('.scroll_to_top');
    scrollToTop.click(function(e) {
        e.preventDefault();

        $('html,body').animate({
            scrollTop: 0
        }, 1200);
    });
}

// Scroll To Section
$('.scroll-to-sec').click(function() {

    $('html, body').animate({

        scrollTop: $('#' + $(this).data('scroll')).offset().top

    }, 500);

});

// image Parallax

$('.img-parallax').each(function() {
    var img = $(this);
    var imgParent = $(this).parent();

    function parallaxImg() {
        var speed = img.data('speed');
        var imgY = imgParent.offset().top;
        var winY = $(this).scrollTop();
        var winH = $(this).height();
        var parentH = imgParent.innerHeight();


        // The next pixel to show on screen
        var winBottom = winY + winH;

        // If block is shown on screen
        if (winBottom > imgY && winY < imgY + parentH) {
            // Number of pixels shown after block appear
            var imgBottom = ((winBottom - imgY) * speed);
            // Max number of pixels until block disappear
            var imgTop = winH + parentH;
            // Porcentage between start showing until disappearing
            var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
        }
        img.css({
            top: imgPercent + '%',
            transform: 'translate(-50%, -' + imgPercent + '%)'
        });
    }
    $(document).on({
        scroll: function() {
            parallaxImg();
        },
        ready: function() {
            parallaxImg();
        }
    });
});

// Menu Toggle
$('.main-nav .navbar-toggler').click(function() {
    $('.main-nav .menu-toggle').toggleClass('is-active');
});

// if ($('.text-toggle').length) {
//     // Text Toggle
//     var defaultHeight = 50,
//         text = $(".text-toggle"),
//         textHeight = text[0].scrollHeight,
//         button = $(".btn-text-toggle");
//     text.css({ "max-height": defaultHeight, "overflow": "hidden" });
//     $('.less-text').hide();
//     button.on("click", function() {
//         let newHeight = 0;
//         if (text.hasClass("active")) {
//             newHeight = defaultHeight;
//             text.removeClass("active");
//             $('.more-text').show();
//             $('.less-text').hide();
//         } else {
//             newHeight = textHeight;
//             text.addClass("active");
//             $('.more-text').hide();
//             $('.less-text').show();
//         }
//         text.animate({
//             "max-height": newHeight
//         }, 500);
//         // console.log(newHeight);
//     });
// }

if ($('.text-toggle').length) {
    // Text Toggl

    $(".btn-text-toggle").each(function(index) {
        let button = $(this),
            defaultHeight = 50,
            text = button.parent().find('.text-toggle'),
            textHeight = text[0].scrollHeight,
            newHeight = 0;
        $(".text-toggle").css({ "max-height": defaultHeight, "overflow": "hidden" });
        $('.less-text').hide();

        button.on("click", function() {
            if (text.hasClass("active")) {
                newHeight = defaultHeight;
                text.removeClass("active");
                button.find('.more-text').show();
                button.find('.less-text').hide();
            } else {
                newHeight = textHeight;
                text.addClass("active");
                button.find('.more-text').hide();
                button.find('.less-text').show();
            }
            text.animate({
                "max-height": newHeight
            }, 500);
            // console.log(newHeight);
        });
    });
}


$('body').css('paddingTop', $('.cd-auto-hide-header .main-nav').innerHeight());

$('.fullscreen_banner .single-item').css({
    'height': 'calc(100vh - ' + $('.cd-auto-hide-header').innerHeight() + 'px)'
});

$('.fixed-icons-top').css({
    'top': $('.cd-auto-hide-header .main-nav').innerHeight() + 10
});

// Go To Video id

var video_id = window.location.hash;
if (video_id.length && $(video_id).length) {
    $('html, body').animate({
        scrollTop: 0
    }, 0);
    setTimeout(function() {
        $('html, body').animate({
            scrollTop: $(video_id).offset().top
        }, 2000);
    }, 1000)

}